import React from 'react';
import { Info } from '../components/Info.js'; 



function IBuyComics()
{
 return(

    <>


    <div className="text-wrapper">

        <Info header = "I Buy Comics" paragraph = "I am always interested in buying comics individually through large collections! I can travel to you at a time that is convenient for your schedule. I have traveled worldwide to purchase comics and comic collections. 
         Let's not let geography get in our way!"/>

        <Info header = "How To Sell To Me" paragraph = "If you are interested in selling, please contact me via email and provide me with as much detail as you can.  
                    Preferably a list with titles, issue numbers and approximate grades if possible. You can include pictures as well!
               
                    I probably won’t be able to make a firm offer without viewing as condition is extremely important with comics."/>

        <Info header = "" paragraph = "Appraisals:  I provide appraisals for a fee as time and workload permit.  The fee depends on the size and vintage of the collection. Please contact me to discuss." />


    
 
    
    </div>

    </>



 );
 
} 


export default IBuyComics;